<template>
  <Modal
    v-model="visible"
    width="800"
    @on-cancel="returnPath"
    :title="`选择${type}`">
    <div class="box-tools pull-right">
      <div style="display: inline-block;margin-right:15px;" @mouseenter="toggleSearch(true)" @mouseleave="toggleSearch(false)">
        <Select v-model="searchBy" class="table-search" :class="{on: tableSearchOn||searchMode||searchBy}">
          <Option value="">不限</Option>
          <Option :value="col.searchKey?col.searchKey:col.key" v-for="col in columns.filter((c)=>{return c.title && c.searchable})" :key="col.key">{{col.title}}</Option>
        </Select>&nbsp;
        <Input v-model="keyword" ref="tableSearch" placeholder="搜索关键字" @on-focus="toggleSearchMode" @on-blur="toggleSearchMode" class="table-search" :class="{on: tableSearchOn||searchMode||keyword}"></Input>&nbsp;
        <Button type="default" icon="ios-search" @click="search"></Button>
      </div>
    </div>
    <div class="box-body" style="clear: both">
      <Table stripe :columns="columns" :data="dataViewPage" ref="table" @on-selection-change="selectRowChange"></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page :total="data.length" size="small" :page-size-opts="[10,20,50,100]" @on-change="changePage" @on-page-size-change="changePageSize" :current="pageCurrent" show-sizer show-elevator></Page>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button class="pull-left" size="large" @click="returnPath">取消</Button>
      <div style="clear:both"></div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ['show', 'type'],
  data () {
    return {
      datatableData: [],
      loading: false,
      userSelected: null,
      modal_loading: false,
      modalDelete: false,
      modalDisable: false,
      modalDetail: false,
      rowSelected: false,
      rowSelectedList: [],
      pageCurrent: 1,
      pageSize: 10,
      keyword: '',
      searchBy: '',
      searchMode: false,
      tableSearchOn: false,
      columns: [
        { title: '用户名', key: 'Username', sortable: true, searchable: true },
        {
          title: '姓名',
          key: 'Name',
          width: 120,
          ellipsis: true,
          sortable: true,
          searchable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        { title: '性别',
          key: 'IsMale',
          sortable: true,
          render: (h, params) => {
            return h('span', {}, this.$common.gender[params.row.IsMale?'1':'0'])
          }
        },
        { title: '身份证号',
          key: 'IdNumber',
          sortable: true,
          searchable: true,
          render: (h, params) => {
            return h('span', {}, this.showIdNumber(params.row.IdNumber))
          }
        },
        { title: '手机号', key: 'MobilePhoneNumber', sortable: true, searchable: true },
        {
          title: '操作',
          key: 'action',
          // fixed: 'right',
          // width: 120,
          render: (h, params) => {
            return h('Button-group', [
              h('Button', {
                props: {
                  type: 'default',
                  size: 'small'
                },
                style: {
                },
                on: {
                  click: () => {
                    this.getUser(params.row.Id)
                  }
                }
              }, '选择')
            ])
          }
        }
      ],
      dataRaw: [],
      data: [],
      dataViewPage: [],
      visible: false
    }
  },
  watch: {
    'show': function (newVal) {
      if (newVal) {
        this.visible = true
        this.initDataTable()
      } else {
        this.visible = false
        this.dataRaw = []
        this.data = []
        this.dataViewPage = []
      }
    },
    'data': function () {
      let vmInstance = this
      this.dataViewPage = this.data.filter(function (item, index) {
        return index < vmInstance.pageSize * vmInstance.pageCurrent && index >= vmInstance.pageSize * (vmInstance.pageCurrent - 1)
      })
    },
    'pageCurrent': function () {
      let vmInstance = this
      this.dataViewPage = this.data.filter(function (item, index) {
        return index < vmInstance.pageSize * vmInstance.pageCurrent && index >= vmInstance.pageSize * (vmInstance.pageCurrent - 1)
      })
    },
    'pageSize': function () {
      let vmInstance = this
      this.dataViewPage = this.data.filter(function (item, index) {
        return index < vmInstance.pageSize
      })
    }
  },
  mounted () {
  },
  methods: {
    initDataTable () {
      this.$Spin.show()
      let perm = 1
      switch (this.type) {
        case '项目管理员':
          perm = 32768
          break
        case '担保公司业务员':
          perm = 512
          break
        default:
          perm = 1
          break
      }
      this.$Api.Auth(this).getUserBriefListByPermission(perm).then((respBody) => {
        this.$Spin.hide()
        this.dataRaw = respBody.UserList
        this.data = respBody.UserList
        this.pageSize = 10
        this.pageCurrent = 1
      })
      .catch(err => {
        this.$Spin.hide()
        this.$Notice.error({
          title: '获取用户列表失败!',
          desc: err.message
        })
      })
    },
    selectRowChange (selection) {
      if (selection.length > 0) {
        this.rowSelected = true
        this.rowSelectedList = selection
      } else {
        this.rowSelected = false
        this.rowSelectedList = []
      }
    },
    changePage (page) {
      this.pageCurrent = page
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
    },
    toggleSearchMode () {
      this.searchMode = !this.searchMode
    },
    toggleSearch (val) {
      this.tableSearchOn = val
    },
    search () {
      let cols = this.columns.filter((col) => {
        return col.searchable
      })
      this.data = this.dataRaw.filter((item) => {
        if (this.searchBy) {
          let content = this.getSearchQueryContent(item, this.searchBy)
          return content.toString().indexOf(this.keyword) >= 0
        } else {
          let found = false
          for (let i = 0; i < cols.length; i++) {
            let col = cols[i]
            let content = this.getSearchQueryContent(item, col.searchKey ? col.searchKey : col.key)
            if (content && (content.toString().indexOf(this.keyword) >= 0)) {
              found = true
            }
          }
          return found
        }
      })
      this.pageCurrent = 0
      this.pageCurrent = 1
    },
    getSearchQueryContent (item, key) {
      if (!key) {
        return ''
      }
      let qArr = []
      let qArrTemp = key.split('.')
      qArrTemp.forEach((q) => {
        if (q.indexOf(']')) {
          let subArr = q.replace(/]/g, '').split('[')
          subArr.forEach((sub) => {
            qArr.push(sub)
          })
        } else {
          qArr.push(q)
        }
      })
      let content = item
      qArr.forEach((query) => {
        if (content[query]) {
          content = content[query]
        } else {
          content = ''
        }
      })
      return content
    },
    getUser (userId) {
      this.userSelected = null
      this.userSelected = this.dataRaw.filter(function (item) {
        return item.Id === userId
      })[0]
      this.$emit('returnPerson', this.userSelected)
      this.returnPath()
    },
    refreshList () {
      this.initDataTable()
      this.searchBy = ''
      this.keyword = ''
      this.searchMode = false
      this.tableSearchOn = false
    },
    returnPath () {
      this.$emit('close')
      this.$Modal.remove()
    },
    showIdNumber (id) {
      let idnumber = ''
      if (id) {
        if (id.length === 18) {
          // idnumber = id.substr(0, 6) + '****' + id.substr(14, 18)
          idnumber = id.substr(0, 10) + '****'
        } else if (id.length === 15) {
          idnumber = id.substr(0, 8) + '****'
        }
      }
      return idnumber
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box-tools {
  display: flex;
}
.table-search {
  transition: width 0.3s ease-in-out;
  width: 0;
  overflow: hidden;
}
.table-search.on {
  width: 120px;
}
</style>
